import { Component, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: true,
    imports: [MatToolbarModule]
})

export class FooterComponent implements OnInit {
  public version;

  constructor( ) {
  }

  ngOnInit() {
    this.version = appVersion;
  }

}
